import styled from 'styled-components'

import MEDIA from 'constants/media'


const AccordionWrap = styled.div`
  margin: 40px 0 0 0;
  h4 {
    margin-bottom: 5px;
  }
  .accordion {
    text-align: left;
    max-width: 800px;
    margin: auto;
  }
  .accordion__item {
    border-top: 2px solid #cccccc;
    position: relative;
    padding: 30px 0;
    padding-left: 20px;
  }
  .accordion__item__gold {
    position: relative;
  }

  .accordion__button {
    font-size: 30px;
    font-family: futura-pt, sans-serif;
    font-weight: 600;
    cursor: pointer;
    width: 100%;
    text-align: left;
    border: none;
    &:focus {
      outline: none;
    }
  }

  .accordion__button:after {
    content: '';
    width: 40px;
    height: 20px;
    position: absolute;
    right: 20px;
    top: 40px;
    background: transparent url(/images/icons/Arrow.svg) no-repeat center
      center;
    background-size: contain;
    transform: rotate(-90deg);
  }

  .accordion__button[aria-expanded='true']::after,
  .accordion__button[aria-selected='true']::after {
    transform: rotate(0);
  }
  .accordion__heading {
    margin: auto;
  }
  .accordion__panel {
    font-size: 24px;
    padding: 20px;
    animation: fadein 0.35s ease-in;
    text-align: left;
    max-width: none;
  }

  /* -------------------------------------------------- */
  /* ---------------- Animation part ------------------ */
  /* -------------------------------------------------- */

  @keyframes fadein {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  ${MEDIA.xsmall`
    .accordion__item,
    .accordion__item__gold {
      padding-left: 20px;
    }
  `}
  ${MEDIA.medium`
    .accordion__button {
      font-size: 32px;
    }
    .accordion__panel {
      padding: 20px;
    }
  `}
`

export default AccordionWrap
